<template>
  <v-row v-if="loading">
    <v-col class="pb-6 pt-6 text-center">
      <v-progress-circular indeterminate color="primary" :width="2" :size="24" />
    </v-col>
  </v-row>
  <v-list class="transparent" v-else-if="sources.length">
    <v-list-item class="py-2" v-for="d in sources" :key="d.id">
      <v-row align="center" no-gutters>
        <v-col cols="12" sm="3">
          <span class="d-block body-2 text--secondary font-weight-medium">
            <template v-if="d.description">{{d.description}}</template><template v-else>Solicitud de tarjeta</template>
          </span>
          <span class="d-block body-2 text--disabled">
            <template v-if="d.recipient">Enviada a {{d.recipient}} • </template>{{d.created | dateTime}}
          </span>
        </v-col>
        <v-col cols="12" sm="3">
          <v-chip :color="statusInfo(d.status).color" :text-color="statusInfo(d.status).textColor" label small>{{statusInfo(d.status).label}}</v-chip>
        </v-col>
        <v-col cols="12" sm="4">
          <div class="d-flex align-center">
            <span class="body-2 text--disabled">a través de</span>
            <img class="ml-2" v-if="gatewayBrand(d.gateway)" :src="gatewayBrand(d.gateway)" :alt="d.gateway" height="20">
            <span class="ml-2 body-2 text--secondary font-weight-medium" v-else>{{gatewayName(d.gateway)}}</span>
          </div>
        </v-col>
        <v-col class="text-right" cols="12" sm="2">
          <v-btn @click="destroySource(d)" outlined color="red darken-2" retain-focus-on-click><v-icon small left>mdi-delete</v-icon>Eliminar</v-btn>
        </v-col>
      </v-row>
    </v-list-item>
  </v-list>
  <v-row v-else>
    <v-col class="pb-6 pt-4 text-center">
      <v-icon class="d-block" color="secondary" size="70">mdi-email-fast-outline</v-icon>
      <span class="d-block subtitle-1 my-2">Sin solicitudes en tránsito</span>
    </v-col>
  </v-row>
</template>
<script>
import GenericViewMixin from '@/mixins/GenericViewMixin'

/**
 * Spanish label + Vuetify colors for the statuses of a card inscription request
 * (a reusable source that has not become chargeable yet). `failed` refers to a
 * failed inscription, not to a failed charge.
 * @type {Object<string, { label: string, color: string, textColor: string }>}
 */
const REQUEST_STATUS = {
  waiting_authorization: { label: 'Esperando al cliente', color: 'amber lighten-5', textColor: 'amber darken-4' },
  requires_authorization: { label: 'Pendiente de autorización', color: 'blue lighten-5', textColor: 'blue darken-2' },
  failed: { label: 'Inscripción fallida', color: 'red lighten-5', textColor: 'red darken-2' }
}

export default {
  mixins: [
    GenericViewMixin
  ],
  props: {
    sources: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    loading: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    }
  },
  methods: {
    statusInfo (status) {
      return REQUEST_STATUS[status] || { label: status, color: 'defaultGrey', textColor: 'secondary' }
    },
    gatewayBrand (gateway) {
      /**
       * The brand asset does not exist for every gateway, and `require` throws
       * when it is missing, so it falls back to a generic icon.
       */
      try {
        return require(`@/assets/appAsset-brand--${gateway}.svg`)
      } catch (error) {
        return null
      }
    },
    gatewayName (gateway) {
      return this.$te(gateway) ? this.$t(gateway) : gateway
    },
    destroySource (instance) {
      this.$dialog.warning({
        title: 'Cancelar solicitud de tarjeta',
        text: `
          <span class="d-block mb-4">Al cancelar la solicitud el enlace enviado a tu cliente dejará de funcionar.</span>
          <span class="d-block my-4">¿Estás seguro de continuar?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
              this.$emit('destroy', instance)
            }
          }
        ]
      })
    }
  }
}
</script>
